import { DynamicFormV2Palette } from "@mui/material";

export type FormThermometerComponentTokenType = {
  backgroundColor: string;
  textColor: string;
  progressTrackBackgroundColor: string;
  progressBarBackgroundColor: string;
  heartsColor: string;
  contributionHeadColor: string;
  contributionBloomColor: string;
};

export const assignThermometerComponentTokens = (
  formsPalette: DynamicFormV2Palette["forms"],
  mode: "light" | "dark",
  isDull: boolean
) => {
  const isLightMode = mode === "light";

  const getContributionBloomColor = () => {
    if (isDull) {
      return formsPalette.border.positive;
    }
    return isLightMode ? formsPalette.surface.intense : "#ffffff";
  };

  return {
    backgroundColor: isLightMode ? formsPalette.surface.quiet : formsPalette.surface.supershy,
    textColor: isLightMode ? formsPalette.text.moderate : formsPalette.text.intense,
    progressTrackBackgroundColor: formsPalette.surface.moderate,
    progressBarBackgroundColor: isLightMode ? formsPalette.surface.intense : formsPalette.surface.reverse,
    heartsColor: formsPalette.surface.moderate,
    contributionHeadColor: isDull ? formsPalette.border.positive : "#ffffff",
    contributionBloomColor: getContributionBloomColor(),
  } as FormThermometerComponentTokenType;
};
